import React, { useState } from "react";
import "../css/Trivia.css";


const allQuestions = [
  {
    question: "When was the Premier League founded?",
    options: ["1992", "1982", "1972", "2002"],
    answer: 0,
  },
  {
    question: "Which team has won the most Premier League titles?",
    options: ["Manchester United", "Liverpool", "Chelsea", "Arsenal"],
    answer: 0,
  },
  {
    question: "Which of these teams is known as 'The Blues'?",
    options: ["Arsenal", "Chelsea", "Liverpool", "Manchester United"],
    answer: 1,
  },
  {
    question: "Which club’s home ground is Anfield?",
    options: ["Everton", "Liverpool", "Manchester City", "Tottenham Hotspur"],
    answer: 1,
  },
  {
    question: "Which team is nicknamed 'The Gunners'?",
    options: ["Arsenal", "Aston Villa", "Burnley", "West Ham United"],
    answer: 0,
  },
  {
    question: "Who is the Premier League's all-time top scorer?",
    options: ["Alan Shearer", "Wayne Rooney", "Sergio Agüero", "Thierry Henry"],
    answer: 0,
  },
  {
    question: "Which club is known as 'The Foxes'?",
    options: ["Leicester City", "Wolves", "Everton", "West Ham"],
    answer: 0,
  },
  {
    question: "Which team plays at Old Trafford?",
    options: ["Manchester United", "Manchester City", "Liverpool", "Chelsea"],
    answer: 0,
  },
  {
    question: "Who won the Premier League in the 2015-16 season?",
    options: ["Leicester City", "Chelsea", "Manchester City", "Arsenal"],
    answer: 0,
  },
  {
    question: "Which club is nicknamed 'The Toffees'?",
    options: ["Everton", "Burnley", "Crystal Palace", "Brighton"],
    answer: 0,
  },
  {
    question: "Which club plays their home games at the Etihad Stadium?",
    options: ["Manchester United", "Manchester City", "Leeds United", "Aston Villa"],
    answer: 1,
  },
  {
    question: "Which team is nicknamed 'The Reds' in the Premier League?",
    options: ["Arsenal", "Manchester United", "Liverpool", "Both B and C"],
    answer: 3,
  },
  {
    question: "How many players are on the field per team in a standard soccer match?",
    options: ["9", "10", "11", "12"],
    answer: 2,
  },
  {
    question: "Which Premier League club is known as 'The Spurs'?",
    options: ["Chelsea", "Arsenal", "Tottenham Hotspur", "West Ham"],
    answer: 2,
  },
  {
    question: "Who scored the famous 'Hand of God' goal?",
    options: ["Pelé", "Ronaldo", "Diego Maradona", "Zinedine Zidane"],
    answer: 2,
  },
  {
    question: "Which country has won the most FIFA World Cups?",
    options: ["Germany", "Argentina", "Italy", "Brazil"],
    answer: 3,
  },
  {
    question: "What color card is shown for a player's dismissal from the game?",
    options: ["Blue", "Orange", "Red", "Black"],
    answer: 2,
  },
];

function getRandomQuestions(arr, n) {
  const shuffled = arr.slice().sort(() => 0.5 - Math.random());
  return shuffled.slice(0, n);
}


function Trivia() {
  const [questions, setQuestions] = useState(() => getRandomQuestions(allQuestions, 5));
  const [current, setCurrent] = useState(0);
  const [selected, setSelected] = useState(null);
  const [score, setScore] = useState(0);
  const [showScore, setShowScore] = useState(false);
  const [playCount, setPlayCount] = useState(() => {
    const stored = localStorage.getItem('triviaPlayCount');
    return stored ? parseInt(stored, 10) : 0;
  });
  const [lastScore, setLastScore] = useState(() => {
    const stored = localStorage.getItem('triviaLastScore');
    return stored ? parseInt(stored, 10) : 0;
  });

  const handleOptionClick = (idx) => {
    setSelected(idx);
  };

  const handleNext = () => {
    if (selected === questions[current].answer) {
      setScore(score + 1);
    }
    setSelected(null);
    if (current < questions.length - 1) {
      setCurrent(current + 1);
    } else {
      // End of quiz: update play count and last score in localStorage
      const newPlayCount = playCount + 1;
      localStorage.setItem('triviaPlayCount', newPlayCount);
      localStorage.setItem('triviaLastScore', selected === questions[current].answer ? score + 1 : score);
      setPlayCount(newPlayCount);
      setLastScore(selected === questions[current].answer ? score + 1 : score);
      setShowScore(true);
    }
  };

  const handleRestart = () => {
    setQuestions(getRandomQuestions(allQuestions, 5));
    setCurrent(0);
    setSelected(null);
    setScore(0);
    setShowScore(false);
  };

  return (
    <div className="trivia-card">
      <h2>Premier League Trivia</h2>
      {showScore ? (
        <div>
          <h3>Your score: {lastScore} / {questions.length}</h3>
          <p>You have played {playCount} {playCount === 1 ? 'time' : 'times'}.</p>
          <button className="trivia-next-btn" onClick={handleRestart}>Play Again</button>
        </div>
      ) : (
        <div>
          <h4>Question {current + 1} of {questions.length}</h4>
          <p>{questions[current].question}</p>
          <div className="trivia-options">
            {questions[current].options.map((opt, idx) => (
              <button
                key={idx}
                onClick={() => handleOptionClick(idx)}
                className={"trivia-option-btn" + (selected === idx ? " selected" : "")}
              >
                {opt}
              </button>
            ))}
          </div>
          <button
            className="trivia-next-btn"
            onClick={handleNext}
            disabled={selected === null}
          >
            {current === questions.length - 1 ? "Finish" : "Next"}
          </button>
        </div>
      )}
    </div>
  );
}

export default Trivia;
